import { TeamBillingState, TeamBillingAction } from './types'

export const initialState: TeamBillingState = {
  billingItems: [],
  loading: true,
  billingLoading: false,
  error: null,
  currencyCode: 'USD',
}

export function billingReducer(
  state: TeamBillingState,
  action: TeamBillingAction
): TeamBillingState {
  switch (action.type) {
    case 'SET_LOADING':
      return { ...state, loading: action.payload }
    case 'SET_BILLING_LOADING':
      return { ...state, billingLoading: action.payload }
    case 'SET_ERROR':
      return { ...state, error: action.payload }
    case 'SET_BILLING_ITEMS':
      return { ...state, billingItems: action.payload }
    case 'SET_CURRENCY_CODE':
      return { ...state, currencyCode: action.payload }
    default:
      return state
  }
}
